module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    attrs: {
      "id": "player"
    }
  }, [(!_vm.userStart) ? _c('div', [(_vm.boxConfig.meta) ? _c('h1', [_vm._v(_vm._s(_vm.$store.state.meta.title))]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Lower octave: 'Q', 'W', 'E', 'R', 'T'")]), _vm._v(" "), _c('h3', [_vm._v("Upper octave: 'H', 'J', 'K', 'L', ';'")]), _vm._v(" "), _c('h4', [_vm._v("composition lasts " + _vm._s(_vm.$store.state.meta.length) + " seconds")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$store.state.meta.intro))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.start
    }
  }, [_vm._v("Start")]), _vm._v(" "), _c('label', {
    attrs: {
      "id": "new"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/make"
    }
  }, [_vm._v("Make A New One")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.userStart) ? _c('div', [_c('player', {
    on: {
      "ended": _vm.ended
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.userStart) ? _c('u3c', {
    attrs: {
      "config": this.u3c
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64a88031"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue
// module id = 283
// module chunks = 1